import { useState } from "react";
import { packResources } from "@/mocks/home";

export default function PackSection() {
  const [savedIds, setSavedIds] = useState<string[]>([]);

  const toggleSave = (id: string) => {
    setSavedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <section
      id="packs"
      className="w-full border-y border-background-200/70 bg-background-100 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-inbox-archive-line"></i>
              </span>
              PACK ZONE
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              黑料打包专区
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              把散落条目整理成包，按话题与年份双重排序，拿到的是一份完整目录。
            </p>
          </div>
          <span className="whitespace-nowrap rounded-full bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700 ring-1 ring-background-200">
            本期共 57 份整理包
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {packResources.map((pack) => {
            const saved = savedIds.includes(pack.id);
            return (
              <article
                key={pack.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
              >
                <div className="h-44 w-full overflow-hidden">
                  <img
                    src={pack.image}
                    alt={`${pack.title} - 黑料打包资源整理包`}
                    title={`${pack.title} - 黑料打包`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-medium text-primary-800">
                      {pack.format}
                    </span>
                    <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800">
                      {pack.size}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
                    {pack.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {pack.desc}
                  </p>
                  <div className="mt-4 flex items-center gap-4 border-t border-background-200/70 pt-3 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-download-2-line"></i>
                      </span>
                      {pack.downloads}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-calendar-line"></i>
                      </span>
                      {pack.updated}
                    </span>
                  </div>
                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
                    >
                      查看目录
                    </button>
                    <button
                      type="button"
                      onClick={() => toggleSave(pack.id)}
                      aria-pressed={saved}
                      className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border px-3.5 py-2.5 text-sm transition-colors ${
                        saved
                          ? "border-accent-300 bg-accent-100 font-medium text-accent-800"
                          : "border-background-200 text-foreground-700 hover:border-accent-300 hover:text-accent-700"
                      }`}
                    >
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className={saved ? "ri-bookmark-fill" : "ri-bookmark-line"}></i>
                      </span>
                      {saved ? "已收藏" : "收藏"}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <p className="mt-5 text-center text-xs text-foreground-500">
          以上整理包与内容均为示例展示，本页不提供实际下载或上传入口。
        </p>
      </div>
    </section>
  );
}